var site = site || {};
var generic = generic || {};

(function ($, Drupal) {
  'use strict';

  var homepageEmailSignupV1 = {
    formatter: $('.email-sms-signup-ca-v1'),
    pc_email_optin: typeof site.userInfoCookie == 'undefined' ?
      0 :
      parseInt(site.userInfoCookie.getValue('pc_email_optin'))
  };

  Drupal.behaviors.homepageEmailSignupV1 = {
    get: function (key) {
      return homepageEmailSignupV1[key];
    },

    set: function (key, val) {
      homepageEmailSignupV1[key] = val;
    },

    showAlternateContent: function (thisFormatter) {
      thisFormatter.find('.site-email-sms-signup__thank-you').addClass('hidden');
      thisFormatter.find('.site-email-sms-signup__form').addClass('hidden');
      thisFormatter.find('.site-email-sms-signup__alternate').removeClass('hidden');
    },

    attach: function (context, settings) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        // For each instance of email signup field, listen for successful gnav
        // data results.
        // Moved here by Bloom to allow gnavdata.js to not be coupled to any
        // implementations of its data
        $(window).on('gnavdata_success', function (e, gNavData) {
          sessionStorage.email_address = '';
          if (!_.isNull(gNavData) && !_.isEmpty(gNavData.EMAIL_ADDRESS)) {
            sessionStorage.email_address = gNavData.EMAIL_ADDRESS;
          }

          if (!_.isEmpty(sessionStorage.email_address)) {
            var emailField = thisFormatter.find('#form--email_sms_signup--field--PC_EMAIL_ADDRESS');

            emailField.val(sessionStorage.email_address);
          }
        });

        if (self.get('pc_email_optin')) {
          self.showAlternateContent(thisFormatter);
        } else {
          // show checkbox when mobile input is focused
          thisFormatter.find('#form--email_sms_signup--field--MOBILE_NUMBER').focus(function () {
            thisFormatter.find('.form-checkbox-sms-promotions').slideDown(400);
            thisFormatter.find('.form-checkbox-pc-email-promotions').slideUp(400);
          });

          thisFormatter.find('#form--email_sms_signup--field--PC_EMAIL_ADDRESS').focus(function () {
            thisFormatter.find('.form-checkbox-pc-email-promotions').slideDown(400);
            thisFormatter.find('.form-checkbox-sms-promotions').slideUp(400);
          });

          // handle user submitting the email/sms form
          thisFormatter.find('form').submit(function (submitEvt) {
            submitEvt.preventDefault();

            var params = {};

            $.each(thisFormatter.find('form').serializeArray(), function (index, kv) {
              params[kv.name] = kv.value.replace('undefined', '').replace('%40', '@');
            });

            // handle the sms_promotions checkbox - if its checked its being read as 'on' when serialized
            // we need a boolean value
            if (thisFormatter.find('form').find('input[name="SMS_PROMOTIONS"]').prop('checked')) {
              params.SMS_PROMOTIONS = 1;
            }

            generic.jsonrpc.fetch({
              method: 'rpc.form',
              params: [params],
              onSuccess: function (result) {
                // var results = result.getData();
                thisFormatter.find('.site-email-sms-signup__form').fadeOut(400, function () {
                  $(this).addClass('hidden');
                  thisFormatter
                    .find('.site-email-sms-signup__thank-you')
                    .removeClass('hidden')
                    .fadeIn(400, function () {
                      setTimeout(function () {
                        self.showAlternateContent(thisFormatter);
                      }, 4000);
                    });
                });
              },
              onFailure: function (result) {
                var errorObjectsArray = result.getMessages();

                generic.showErrors(
                  errorObjectsArray,
                  thisFormatter.find('.error_messages'),
                  null
                );
              }
            });
          });
        }
      });
    },
    attached: false
  };
})(jQuery, Drupal);
